import React, { useCallback, useEffect, useRef, useState } from "react";
import "../../../sass/style.scss";
import { VisibilityProvider } from "../../context/VisibilityContext";
import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";
import Navbar from "../../layout/Navbar/Navbar";
import Activity from "../../sections/Activity/Activity";
import Advantages from "../../sections/Advantages/Advantages";
import Gallery from "../../sections/Gallery/Gallery";
import History from "../../sections/History/History";

function App() {
	useEffect(() => {
		document.title = "GLuck Esports";
	});

	const [isNavbarVisible, setIsNavbarVisible] = useState(true);
	const galleryRef = useRef(null);

	const controlNavbar = useCallback(() => {
		if (!galleryRef.current) return;

		const scrollY = window.scrollY;
		const galleryPosition = galleryRef.current.offsetTop;
		const offset = 400;

		setIsNavbarVisible(scrollY < galleryPosition - offset);
	}, []);

	useEffect(() => {
		window.addEventListener("scroll", controlNavbar, { passive: true });
		controlNavbar();
		return () => window.removeEventListener("scroll", controlNavbar);
	}, [controlNavbar]);

	return (
		<VisibilityProvider>
			<div className="App home-page">
				<Navbar isVisible={isNavbarVisible} />

				<div className="main-content">
					<Header />
					<Activity />
					<History />
					<Advantages />
					<div ref={galleryRef}>
						<Gallery />
					</div>
				</div>
				<Footer alwaysVisible />
			</div>
		</VisibilityProvider>
	);
}

export default App;
